import { useMemo } from 'react';
import { observer, useLocalObservable } from 'mobx-react';
import { formatDateDDMMYYYY } from '../../../utils/utils';
import IconButton, { ICON_BUTTON_TYPES } from '../../../components/buttons/IconButton';
import { paths } from '../../../utils/constants/routes';
import { buildProjectResultsUrl } from '../../../utils/profiler/buildProjectResultsUrl';
import { useStore } from '../../../store/store';
import { SELECTED_PROJECT_TABS, SHARED_PROJECT_TYPE_TABS } from './constants';
import { FUND_FIELDS } from '../../../utils/constants/fields';
import pubSub from '../../../utils/pubsub';
import ChipsList from '../../../components/common/ChipsList';
import { useProjectRowOpen } from '../../../hooks/useProjectRowOpen';
const SEARCH_TYPES = {
  funds: 'Fund',
  portfolios: 'Portfolio company',
  investprofiles: 'Invest profile'
};

const SharedProjectEntry = observer(({ project, params, index }) => {
  const { authStore, utilsStore } = useStore();
  const state = useLocalObservable(() => ({
    get layout() {
      return utilsStore.windowWidth < 1201 ? 'mobile' : 'desktop';
    }
  }));

  const getRequestUrl = () =>
    buildProjectResultsUrl(paths.TEAM, params, project.id, SELECTED_PROJECT_TABS.RESULTS);

  const { onClick: onOpenRequestClick, linkContextMenu: requestMenu } = useProjectRowOpen(
    getRequestUrl,
    () => pubSub.publish({ event: 'team-saved-project-list-scroll-y' })
  );

  const foundProjectUser = useMemo(() => {
    const foundUser = authStore.companyUsers.find((u) => u.id === project.ownerId);
    if (foundUser) {
      return `${foundUser.firstName} ${foundUser.lastName}`;
    }
    return 'unknown';
  }, [project, authStore]);

  const foundUser = useMemo(() => {
    return project.sharedUsers.find((user) => user.id === authStore.currentUserId);
  }, [project, authStore]);

  if (state.layout === 'mobile') {
    return (
      <div className="mobile-project-entry" style={index === 0 ? { marginTop: '8px' } : {}}>
        <div className="project-name">{project.name}</div>
        <div className="project-property-row">
          <div className="project-property-field">Sender name</div>
          <div className="project-property-value">{foundProjectUser}</div>
        </div>
        <div className="project-property-row">
          <div className="project-property-field">Profile</div>
          <div className="project-property-value">{SEARCH_TYPES[project.searchType]}</div>
        </div>
        <div className="project-property-row">
          <div className="project-property-field">Industries</div>
          <div className="project-property-value">
            {/* {utilsStore
              .shortenList(utilsStore.getOptionName(project.fields, FUND_FIELDS.INDUSTRIES))
              .join(', ')} */}
            <ChipsList list={utilsStore.getOptionName(project.fields, FUND_FIELDS.INDUSTRIES)} />
          </div>
        </div>
        <div className="project-property-row">
          <div className="project-property-field">Results</div>
          <div className="project-property-value">{project.resultsCount}</div>
        </div>
        <div className="project-property-row">
          <div className="project-property-field">
            {params.projectTypeTab === SHARED_PROJECT_TYPE_TABS.PENDING
              ? 'Date received'
              : 'Date resolved'}
          </div>
          <div className="project-property-value">
            {formatDateDDMMYYYY(
              params.projectTypeTab === SHARED_PROJECT_TYPE_TABS.PENDING
                ? foundUser?.dateReceived
                : foundUser?.dateResolved
            )}
          </div>
        </div>

        <div className="project-actions-row">
          <IconButton
            type={ICON_BUTTON_TYPES.BLUE}
            innerText="Open request"
            onClick={onOpenRequestClick}
            filled
            wrapClassName="open-feedback-request-btn"
            linkContextMenu={requestMenu}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="row" style={index === 0 ? { marginTop: '8px' } : {}}>
      <div className="item">
        <div className="label">Sender Name</div>
        <div className="value">{foundProjectUser}</div>
      </div>
      <div className="item">
        <div className="label">Project name</div>
        <div className="value">{project.name}</div>
      </div>
      <div className="item">
        <div className="label">Profile</div>
        <div className="value">{SEARCH_TYPES[project.searchType]}</div>
      </div>
      <div className="item">
        <div className="label">Industries</div>
        <div className="value">
          {/* {utilsStore
            .shortenList(utilsStore.getOptionName(project.fields, FUND_FIELDS.INDUSTRIES))
            .join(', ')} */}
          <ChipsList list={utilsStore.getOptionName(project.fields, FUND_FIELDS.INDUSTRIES)} />
        </div>
      </div>
      <div className="item">
        <div className="label">Results</div>
        <div className="value">{project.resultsCount}</div>
      </div>
      <div className="item">
        <div className="label">
          {params.projectTypeTab === SHARED_PROJECT_TYPE_TABS.PENDING
            ? 'Date received'
            : 'Date resolved'}
        </div>
        <div className="value">
          {formatDateDDMMYYYY(
            params.projectTypeTab === SHARED_PROJECT_TYPE_TABS.PENDING
              ? foundUser?.dateReceived
              : foundUser?.dateResolved
          )}
        </div>
      </div>

      <div className="actions">
        <IconButton
          type={ICON_BUTTON_TYPES.BLUE}
          innerText="Open request"
          onClick={onOpenRequestClick}
          filled
          linkContextMenu={requestMenu}
        />
      </div>
    </div>
  );
});

export default SharedProjectEntry;
